import { get } from 'lodash';
import { createSelector } from 'reselect';

import { getExportColumnOptions } from './../../helper/importExport';

const root = state => get(state, 'UtilitiesState.importExport');

export const getImportItems = state =>
  get(root(state), 'importItems', {
    Data: [],
    Errors: [],
  });
export const getImportItemsLoading = state =>
  get(root(state), 'importItemsLoading', false);

export const getExistingExportConfigLoading = state =>
  get(root(state), 'fetchExistingExportConfigLoading', false);

export const getColumnsLoading = state =>
  get(root(state), 'fetchColumnsLoading', false);

export const getColumns = state => get(root(state), 'columns', []);

export const getColumnsLoadingError = state =>
  get(root(state), 'fetchColumnsLoadingError', null);

export const getExistingExportConfig = state =>
  get(root(state), 'existingExportConfig', []);

export const getExistingExportConfigLoadingError = state =>
  get(root(state), 'fetchExistingExportConfigLoadingError', null);

export const getLoadPreviousOptionsDropDown = state =>
  get(root(state), 'loadPreviousOptionsDropDown', []);
export const isSubmitted = state => get(root(state), 'submitted', false);
export const getSubmitError = state => get(root(state), 'submitError', null);
export const getImportItemsDataLoading = state =>
  get(root(state), 'importItemsDataLoading', false);
export const getImportItemsData = state =>
  get(root(state), 'importItemsData', null);
export const getImportItemsDataLoadingError = state =>
  get(root(state), 'importItemsDataLoadingError', null);
export const getDeleteConfigLoading = state =>
  get(root(state), 'deleteConfigLoading', false);
export const getDeleteConfigLoadingError = state =>
  get(root(state), 'deleteConfigLoadingError', null);
export const getDeleteConfigData = state =>
  get(root(state), 'deleteConfigData', null);
export const getExistingImportConfigLoading = state =>
  get(root(state), 'fetchExistingImportConfigLoading', false);
export const getExistingImportConfig = state =>
  get(root(state), 'existingImportConfig', []);
export const getExistingImportConfigLoadingError = state =>
  get(root(state), 'fetchExistingImportConfigLoadingError', null);
export const getLoadPreviousImportOptionsDropDown = state =>
  get(root(state), 'loadPreviousImportOptionsDropDown', []);
export const isFileEmpty = state => get(root(state), 'isFileEmpty', false);
export const isOnlyOneItemPresent = state =>
  get(root(state), 'onlyOneItemPresent', false);

export const isSubmitting = state => get(root(state), 'submitting', false);

export const getColumnMapping = state => get(root(state), 'columnMapping', []);
export const getExportColumns = createSelector(
  getColumns,
  columns => getExportColumnOptions(columns)
);



// WEBPACK FOOTER //
// ./src/pages/utilities/state/importExport/selector.js